export interface FilePreviewProps {
  fileName: string;
  fileType: string;
  previewUrl: string;
}

/**
 * Aperçu du document importé : image pour les images,
 * vignette descriptive pour les PDF.
 */
export function FilePreview({ fileName, fileType, previewUrl }: FilePreviewProps) {
  if (fileType === 'application/pdf') {
    return (
      <div
        data-testid="file-preview"
        className="flex h-full min-h-64 flex-col items-center justify-center gap-3 rounded-lg border border-slate-200 bg-slate-50 p-6 text-center"
      >
        <span className="rounded-md bg-red-100 px-3 py-1 text-xs font-semibold text-red-700">
          PDF
        </span>
        <p className="max-w-full truncate text-sm font-medium text-slate-700">{fileName}</p>
        <p className="text-xs text-slate-500">Aperçu non disponible pour les PDF</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-slate-50">
      <img
        src={previewUrl}
        alt={`Aperçu du document ${fileName}`}
        data-testid="file-preview"
        className="max-h-96 w-full object-contain"
      />
    </div>
  );
}
